<template>
  <div v-if="!permission.capabilities.View" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div><i class="icon-people mr-1"></i>Wallets List</div>
        <router-link to="/wallets/new" :event="permission.capabilities.Create ? 'click' : ''">
          <b-button variant="primary" :disabled="!permission.capabilities.Create">
            <i class="fa fa-plus"></i>&nbsp;New
          </b-button>
        </router-link> 
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">
          <a slot="title" class="hyperlink-without-href" slot-scope="props" title="View" @click="openEditPage(props.row.id)" >
            {{props.row.title}}
          </a>
          <c-switch slot="active" dataOn="" dataOff="" disabled slot-scope="props" color="success" class="mx-1 active-disabled" :checked="props.row.active" label />
          <div slot="action" slot-scope="props" >
            <div class="input-group input-group-sm action">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content" >
                  <i class="fa fa-cog" aria-hidden="true"></i>
                </template>
                <b-dropdown-item @click="openEditPage(props.row.id)" :disabled="!permission.capabilities.Edit"><i class="fa fa-edit"></i>&nbsp;Edit</b-dropdown-item>
                <b-dropdown-item @click="openDeleteModal(props.row.id)" :disabled="!permission.capabilities.Delete"><span style="color: #20a8d8;"><i class="fa fa-trash"></i>&nbsp;Delete</span></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
    <DeleteConfirmModal 
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)" 
      ref="deleteConfirmModal"
    />
    <OrphanRecordsModal 
      v-bind:modalTitle="orphanRecordsModal.modalTitle"
      v-bind:modalMsg="orphanRecordsModal.modalMsg"
      v-on:toggle="orphanRecordsModalOKClick($event)"
      ref="orphanRecordsModal"
    />
    <InfoModal ref="infoModal"></InfoModal>
  </div>
</template>

<script>
  import Vue from 'vue';
  import miniToastr from 'mini-toastr';
  import { Switch as cSwitch } from '@coreui/vue';
  import VueNotifications from 'vue-notifications'
  import {ClientTable, Event} from 'vue-tables-2';
  import { apigClient } from '@/shared/api';
  import { router } from '../../router/index';
  import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
  import OrphanRecordsModal from "./../custom-components/OrphanRecordsModal";
  import InfoModal from "@/shared/Modals.vue";
  import moment from 'moment';
  import 'moment-timezone';
  import Page403 from "@/views/pages/Page403.vue";

  const Spinner = () => import('../shared/Spinner');

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }

  miniToastr.init({types: toastTypes})

  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }

  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  //  VueNotifications.setPluginOptions(options)

  Vue.use(VueNotifications, options)
  Vue.use(ClientTable);

  //Column's customization 
  let columns = ['action', 'walletName', 'walletType', 'walletCount', 'walletSegmentUsageCountTotal', 'activatedCountTotal', 'createdAt', 'active'];
  
  let headings = {
    action: '',
    walletName: 'Name',
    walletType: 'Type',
    walletCount: 'Count',
    walletSegmentUsageCountTotal: 'Segments Used Count',
    activatedCountTotal: "Activated Count",
    createdAt: 'Created',
    active: 'Active',
  }
  let sortable = ['walletName', 'walletCount', 'walletType', 'walletSegmentUsageCountTotal', 'activatedCountTotal', 'createdAt', 'active' ];
  let filterable = ['walletName', 'walletType'];

  //Export component
  export default {
    name: 'Wallets',
    components: {
      cSwitch,
      ClientTable,
      Spinner,
      Event,
      DeleteConfirmModal,
      OrphanRecordsModal,
      InfoModal,
      Page403
    },
    data: function () {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || 'Asia/Bangkok';
    return {
        loginUserInfo: loginUserInfo,
        permission: {
          permissionBaseName: null,
          permissionBaseNameCapabilities: null,
          capabilities: {
            View: false,
            Edit: false,
            Delete: false,
            Create: false,
          }
        },
        userTimezone : userTimezone,
        isLoading: true,
        columns: columns, 
        data: [],
        options: {
          columnsClasses: 'left-align',
          headings: headings,
          sortable: sortable,
          filterable: filterable,
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        
        //Use for delete modal
        deleteModalOpen: false,
        id: null,
        title: null,
        wallet_id: null,
        deleteModal:{
          modalTitle: 'Delete Wallet',
          modalMsg: '',
          loginUserRoleName: loginUserInfo.db.roleName,
          deleteAction: '',
        },
        orphanRecordsModal:{
          modalTitle: 'Orphan Records',
          modalMsg: '',
          deleteOrphanRecords: false,
        },
        orphanRecords: [],
        walletHasOrphanRecords: false,
      }
    },
    methods: {
      getPermission(){
        let that = this;
        const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
        if(this.$route.meta && userPermissionsBasedOnEntity){
          that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
          let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
          if(userPermissionBasedOnEntity){
            that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
            that.permission.permissionBaseNameCapabilities.forEach(capability=>{
              that.permission.capabilities[capability.label] = capability.value
            });
          }
        } else{
          router.push('/no-permission-given');
        }
        console.log('permission: ' , that.permission);
      },
      openDeleteModal : function(id) {
        let that = this;
        that.deleteModal.deleteAction='';
        that.id = id;
        that.wallet_id = that.data[id].wallet_id;
        that.title = that.data[id].walletName;
        that.deleteModal.modalMsg="Delete the Wallet '" + that.title  + "' ?";
        that.$refs.deleteConfirmModal.openModal();
      },
      openEditPage : function(id) {
        if(this.permission.capabilities.Edit) {
          this.id = id;
          this.wallet_id = this.data[id].wallet_id;
          localStorage.setItem('page_wallet_id', this.wallet_id);
          router.push('/wallets/edit');
        }
      },
      loadAndUpdateTableListAfterItemDelete: function(that){
        that.data.splice(that.id, 1);
        for (let i=that.id;i<that.data.length;i++) {
          that.data[i].id--;
        }
        that.isLoading = false;
      },
      changeInfoModalContent(status = null, title = null, message = null) {
        let that = this;
        that.$refs.infoModal.status = status ? status : that.$refs.infoModal.status;
        that.$refs.infoModal.title = title ? title : that.$refs.infoModal.title;
        that.$refs.infoModal.message = message ? message : that.$refs.infoModal.message;
      },
      loadWallets : function() {
        let that = this;
        let method = 'GET';
        let pathTemplate = '/wallets';
        let params = {includeCompanyInfo: false};
        params.filter=[
          {
            fieldname: "isDeleted",
            comparisonOperator: "=",
            value: false
          }
        ];
        if(that.loginUserInfo.db.roleName!='Admin'){
          params.filter.push({
            fieldname: "company_id",
            comparisonOperator: "=",
            value: that.loginUserInfo.db.company.id
          });
        }
        let additionalParams ={
          queryParams: {
            params: JSON.stringify(params)
          }
        };
        let pathParams = {};
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          console.log("result data=",result["data"]["data"]);
          that.data  = result["data"]["data"];
          that.data  = result["data"]["data"].map((elem, index) => { 
              elem.wallet_id = elem.id;
              elem.id = index;
              elem.createdAt = moment(moment.unix(elem.createdAt)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm');
              elem.updateAt = moment(moment.unix(elem.updateAt)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm');
              return elem;
          });
          //that.data = [...data];
          console.log("this.data=",that.data);   
          that.isLoading = false;
          //This is where you would put a success callback
        }).catch( function(error){
          console.log('ERROR ! Cannot get data:' + error);
          that.showErrorMsg();
          //This is where you would put an error callback
        });
      },
      getDeleteAction(data){
        let that = this;
        console.log(data);
        if(data && data.deleteAction){
          that.deleteModal.deleteAction=data.deleteAction;
          that.prepareToDeleteWallet();
        }
      },
      prepareToDeleteWallet: async function(){
        let that = this;
        //this.isLoading = true;
        this.$refs.infoModal.openModal();
        that.changeInfoModalContent(
          "loading",
          "Checking...",
          "Checking the orphaned Records"
        );

        let checkOrphanRecordsOfWalletResult = await that.checkOrphanRecordsOfWallet(that.wallet_id, that.title);
        if(checkOrphanRecordsOfWalletResult=='error' || that.walletHasOrphanRecords){
          return;
        }else{
          that.deleteWallet();
        }
      },
      orphanRecordsModalOKClick(data){
        let that = this;
        console.log(data);
        if(data && data.deleteOrphanRecords && that.deleteModal.deleteAction && that.orphanRecords.length>=1){
          that.deleteWallet();
        }
      },
      deleteWallet(){
        let that = this;
        that.$refs.infoModal.openModal();
        that.changeInfoModalContent(
          "loading",
          "Processing...",
          (that.deleteModal.deleteAction=='MARK-AS-DELETED') ? "Deleting the wallet ("+ that.title +")" :
          "Deleting the wallet ("+ that.title +") permenently"
        );
        let wallet_id = that.wallet_id;  
        let method = 'PUT';
        let pathTemplate = (that.deleteModal.deleteAction=='MARK-AS-DELETED') ? '/wallets/'+wallet_id+'/mark-as-deleted' : '/wallets/'+wallet_id+'/delete';
        let additionalParams ={};
        let pathParams = {};
        let body ={
          orphanRecords: that.orphanRecords,
          updateBy:that.loginUserInfo.login_username
        }
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams,body)
        .then(function(result){
          if(result.data.status){
            console.log(result);
            that.changeInfoModalContent(
              "success",
              "Deleted success!",
              "The Wallet data has been deleted"
            );
            setTimeout(that.$refs.infoModal.closeModal(), 1500);
            
            that.showSuccessMsg();
            that.loadAndUpdateTableListAfterItemDelete(that);
          }else{
            console.log('Error From API Endpoint: ' + result.data.message);
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + result.data.message
            );
          }
          
        }).catch( function(error){
          that.isLoading = false;
          that.changeInfoModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + error.message
          );
        });
      },
      checkOrphanRecordsOfWallet(walletId, walletName){
        let that = this;
        that.orphanRecords=[];
        return new Promise((resolve, reject) => {
          if(walletId){
            apigClient
              .invokeApi({}, '/wallet/'+walletId+'/orphans', "GET", {
                queryParams: {}
              })
              .then(function(result) {
                console.log(result)
                if (result.data.status) {
                  let returnedData = result.data.data;
                  that.orphanRecords = returnedData.orphanRecords;
                  if(that.orphanRecords.length>=1){
                    that.$refs.infoModal.closeModal();
                    that.orphanRecordsModal.modalMsg=!returnedData.oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit ? 
                      "Wallet ('"+ walletName +"') has following orphaned Records. <br/> <b>Click 'Ok'</b> to delete them as well." :
                      "Wallet ('"+ walletName +"') has following orphaned Records. <br/> <p style='color:red'>Cannot delete automatically as some of orphaned records ("+returnedData.entitiesWhichRecordsAreNotFullyFetched.join(", ")+") are not fully loaded to the view because of data limitation. Please delete them manually.</p>"
                    that.$refs.orphanRecordsModal.openModal(that.orphanRecords, returnedData.oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit);
                    that.walletHasOrphanRecords=true;
                  }else{
                    that.walletHasOrphanRecords=false;
                  }
                  resolve('success');
                } else {
                  console.log(`Cannot check Orphan records of wallet against db. Error found from API Endpoint: ${result.data.message}`);
                  that.changeInfoModalContent(
                    "error",
                    "Error Occured!",
                    "Error occurred in checking Orphan records. invokeAPI Error: " + result.message
                  );
                  reject('error');
                }
              })
              .catch(function(error) {
                console.log('Cannot check Orphan records of wallet against db. ERROR:' + error);
                that.changeInfoModalContent(
                  "error",
                  "Error Occured!",
                  "Error occurred in checking Orphan records. ERROR: " + error
                );
                reject('error');
              });
            }else{
              that.changeInfoModalContent(
                "error",
                "Error Occured!",
                "No wallet info provided to check Orphan records."
              );
              reject('error');
            }
        });
      },
    },
    mounted : function() {
      this.getPermission();
      if(!this.permission.capabilities.View){
        return;
      }
      this.loadWallets();
    },
    notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Operation successfull!',
        message: 'The wallet has been deleted'
      },
      showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Hey you',
        message: 'Here is some info for you'
      },
      showWarnMsg: {
        type: VueNotifications.types.warn,
        title: 'Wow, man',
        message: 'That\'s the kind of warning'
      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'ERROR',
        message: 'Error! See console for additional error logs'
      }
    },
  }
</script>
<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style scoped>
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }

  .card-body {
    padding:0!important;
  }
</style>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }
    
    .action{
      display: flex;
      justify-content: center;
      align-items: center;
    } 
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-secondary {
    background-color: none;  
  }

  .modal-dialog {
   color: black;
  }
  
  .container-fluid{
    margin:0!important;
    padding:0!important;
  }

  .breadcrumb{
    margin-bottom:0;
    border-bottom:0;
  }
  #dataTable {
    margin: 18px auto;
  }

  .hyperlink-without-href{
    color: #20a8d8 !important;
    text-decoration: none !important;
    background-color: transparent !important;
  }
  .hyperlink-without-href:hover{
    color: #20a8d8 !important;
    cursor: pointer;
    text-decoration: underline !important;
  }
  .active-disabled .switch-pill .switch-slider{
    opacity: 1 !important;
  }
  #dataTable th{
    text-align:left !important;
  }
  .admin-delete-actions{
    margin-top:10px;
    margin-bottom:10px;
    text-align:center;
  }
  .margin-left-10{
    margin-left: 10px
  }

</style>
